<div
  class="chatbot-messages-body flex-grow-1 overflow-auto text-dark"
  ref="messages_body"
  @scroll.passive="handle_scroll"
>
  <div
    v-if="has_older_messages"
    class="d-flex justify-content-center py-2"
  >
    <button
      class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-2"
      :disabled="is_loading_older_messages"
      @click="$emit('load-older-messages')"
    >
      <i class="bi bi-arrow-up-circle"></i>
      <span>{{ is_loading_older_messages ? "Loading" : "Older messages" }}</span>
    </button>
  </div>

  <div
    v-for="(msg, index) in messages"
    :key="msg.id || 'msg-' + index"
    class="chatbot-message-row d-flex w-100 mb-2"
    :class="msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'"
  >
    <div
      class="chatbot-message-group d-flex flex-column min-w-0"
      :class="msg.sender === 'user' ? 'chatbot-message-group-user align-items-end' : 'chatbot-message-group-assistant align-items-start'"
    >
      <div
        v-if="msg.sender === 'user'"
        class="chatbot-bubble chatbot-bubble-user bg-warning text-dark p-2 rounded-3 shadow-none"
      >
        {{ msg.text }}
      </div>

      <div
        v-else
        class="chatbot-bubble chatbot-bubble-assistant rounded-3 shadow-none"
        :class="msg.is_typing ? 'chatbot-bubble-thinking-shell p-0' : 'p-2 bg-body-tertiary border text-sm'"
      >
        <div v-if="msg.is_typing" class="chatbot-thinking d-flex flex-column w-100 gap-2 min-w-0 text-dark" aria-label="Siyanda Assist is thinking">
          <div class="chatbot-thinking-header d-flex align-items-center justify-content-between gap-2 pt-1 pb-0 px-1">
            <span class="chatbot-thinking-title fw-bold text-sm lh-sm text-dark">Working on your request</span>
            <span
              class="chatbot-thinking-status d-inline-flex align-items-center rounded-pill fw-bold text-nowrap py-1 px-2 text-xxs lh-1 text-dark bg-white border"
              :class="'chatbot-thinking-status-' + get_thinking_status(msg)"
            >
              {{ get_thinking_status_label(msg) }}
            </span>
          </div>

          <div class="chatbot-thinking-activity d-flex flex-column gap-2 w-100 mw-100 p-2 rounded-3 text-dark bg-white border">
            <div
              v-for="(step, step_index) in msg.thinking_steps"
              :key="step.label || step_index"
              class="chatbot-thinking-step position-relative d-flex align-items-start gap-2 p-2 rounded-3 text-xs lh-sm text-dark bg-white border"
              :class="'chatbot-thinking-step-' + step.status"
            >
              <span class="chatbot-thinking-check d-inline-flex align-items-center justify-content-center mt-0 rounded-circle lh-1 text-xs" aria-hidden="true">
                <i v-if="step.status === 'complete'" class="bi bi-check-lg"></i>
                <i v-else-if="step.status === 'failed'" class="bi bi-x-lg"></i>
                <i v-else class="bi bi-arrow-repeat"></i>
              </span>
              <span class="chatbot-thinking-step-body d-flex flex-column gap-1 min-w-0">
                <span class="chatbot-thinking-step-label fw-bold text-sm text-dark">{{ step.label }}</span>
                <span class="chatbot-thinking-step-detail text-xs lh-sm text-secondary">{{ step.detail }}</span>
              </span>
            </div>
          </div>
        </div>
        <span v-else class="chatbot-message-text d-block">{{ get_readable_message_text(msg) }}</span>
      </div>

      <time
        v-if="format_message_timestamp(msg)"
        class="chatbot-message-timestamp text-nowrap mt-1 text-xxs lh-sm text-secondary"
        :datetime="get_message_created_at(msg)"
      >
        {{ format_message_timestamp(msg) }}
      </time>
    </div>
  </div>
</div>
